import { buildStandinUrl } from './buildStandinUrl';

export function navigableStandinUrl(baseUrl?: string | null, devWebAppUrl?: string): string | null {
  if (!baseUrl) return null;

  const href = buildStandinUrl(baseUrl, devWebAppUrl);

  try {
    const { protocol } = new URL(href);
    return protocol === 'http:' || protocol === 'https:' ? href : null;
  } catch {
    return null;
  }
}

export default navigableStandinUrl;
